export const HOME_STALE_TIME_MS = 30 * 1000;
export const COURSES_TAB_STALE_TIME_MS = 60 * 1000;
export const NOTIFICATIONS_STALE_TIME_MS = 30 * 1000;
